import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Mail, MapPin } from 'lucide-react';

import { business, logoImage, serviceArea, social } from '../../content/siteContent.mjs';

const COLUMNS = [
  {
    heading: 'Supply',
    links: [
      { label: 'Wholesale supply', to: '/wholesale' },
      { label: 'Donut menu', to: '/menu' },
      { label: 'Catering packages', to: '/catering' },
    ],
  },
  {
    heading: 'Bakery',
    links: [
      { label: 'Where to find us', to: '/where-to-find-us' },
      { label: 'About & awards', to: '/about' },
      { label: 'Contact', to: '/contact' },
    ],
  },
];

export const PublicFooter = () => (
  <footer className="bg-gray-900 text-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <img
            src={logoImage.src}
            alt={logoImage.alt}
            width={logoImage.width}
            height={logoImage.height}
            loading="lazy"
            className="h-14 w-auto mb-4 brightness-0 invert"
          />
          <p className="max-w-md text-sm text-gray-400 leading-relaxed">
            Wholesale donuts baked overnight in {business.baseTown} and delivered fresh across{' '}
            {business.region} and {business.nearby}. Two-time Best of Westchester winner for Best Donuts.
          </p>
          <div className="mt-5 space-y-2 text-sm">
            <a
              href={`mailto:${business.email}`}
              className="flex items-center gap-2 text-gray-300 hover:text-white transition-colors"
              data-testid="footer-email-link"
            >
              <Mail size={16} /> {business.email}
            </a>
            <p className="flex items-start gap-2 text-gray-400">
              <MapPin size={16} className="mt-0.5 flex-shrink-0" />
              <span>{business.addressLine} — wholesale and catering delivery only, no walk-in counter</span>
            </p>
          </div>
          <div className="mt-5 flex gap-4">
            {social.map((s) => {
              const Icon = s.platform === 'Instagram' ? Instagram : Facebook;
              return (
                <a
                  key={s.platform}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.platform}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  <Icon size={20} />
                </a>
              );
            })}
          </div>
        </div>

        {COLUMNS.map((col) => (
          <div key={col.heading}>
            <h2 className="mb-4 text-sm font-semibold uppercase tracking-wide text-amber-500">{col.heading}</h2>
            <ul className="space-y-2 text-sm">
              {col.links.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-gray-400 hover:text-white transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
              {col.heading === 'Bakery' && (
                <li>
                  <a href="/client/login" className="text-gray-400 hover:text-white transition-colors">
                    Client login
                  </a>
                </li>
              )}
            </ul>
          </div>
        ))}
      </div>

      <div className="mt-12 border-t border-gray-800 pt-8">
        <h2 className="text-sm font-semibold uppercase tracking-wide text-amber-500">Delivery area</h2>
        <p className="mt-3 text-sm leading-relaxed text-gray-400" data-testid="footer-service-area">
          {serviceArea.join(' · ')}
        </p>
        <p className="mt-6 text-xs text-gray-500">
          © {new Date().getFullYear()} {business.legalName}. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
);

export default PublicFooter;
